import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import LazyLoad from 'react-lazyload';
import {
  Section,
  SectionHeader,
  BoxDiscover,
  BoxLayoutMobileSingle,
  YouTubePlayer,
} from 'components';
import './OurEvents.scss';
import { data } from './logic';

class OurEvents extends Component {
  renderBoxes = loadedData =>
    data.map((item, index) => (
      <BoxDiscover
        headline={item.headline}
        description={item.description}
        background={loadedData[item.image].childImageSharp.fluid}
        additionalClass={'connect-page__our-events-box anim-fade-in-bottom'}
        key={`box-culture-${index}`}
        color={item.color}
        link={item.link}
        externalLink
      />
    ));

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            frontClub: file(relativePath: { eq: "culture/front.png" }) {
              childImageSharp {
                fluid(maxWidth: 450) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }

            holacracyMeetup: file(
              relativePath: { eq: "culture/holaman.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 305) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }

            ctoAsks: file(relativePath: { eq: "culture/cto.png" }) {
              childImageSharp {
                fluid(maxWidth: 306) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={loadedData => (
          <Section
            color={'gray-light'}
            additionalClass={'connect-page__our-events'}
            spaceless
            fullwidth
          >
            <div className={'w-container w-container--side-left'}>
              <Section
                color={'red'}
                containerClass={
                  'w-container--left connect-page__right-container'
                }
              >
                <SectionHeader
                  size={'big'}
                  color={'white'}
                  description={
                    'Sharing knowledge helps us grow, stay motivated and stay on-track with frontier technological and design concepts. Developers and business innovators, customers and employees - our events are all about you.'
                  }
                  descriptionColor={'white'}
                  lineColor={'black'}
                  fixed
                >
                  Experience and contribute in-person or&nbsp;via live stream
                </SectionHeader>
                <BoxLayoutMobileSingle>
                  {this.renderBoxes(loadedData)}
                </BoxLayoutMobileSingle>
                <SectionHeader
                  size={'big'}
                  color={'white'}
                  description={
                    'Agile practitioners, security experts, and frontend developers share their expertise and insider tips with knowledge-hungry professionals.'
                  }
                  descriptionColor={'white'}
                  lineColor={'black'}
                  additionalClass={'connect-page__video'}
                  fixed
                >
                  Video
                </SectionHeader>
                <BoxLayoutMobileSingle>
                  <LazyLoad once offset={200} height={720}>
                    <div className={'box connect-page__video-player'}>
                      <YouTubePlayer
                        title={'FrontClub'}
                        src={'https://www.youtube.com/watch?v=zYmW2FpgqwA'}
                      />
                    </div>
                    <div className={'box connect-page__video-player'}>
                      <YouTubePlayer
                        title={'Agile Practitioners'}
                        src={'https://www.youtube.com/watch?v=GUXClhQecfo'}
                        description={
                          'We proudly present the legacy of XSolve - one of Boldare’s founding companies'
                        }
                      />
                    </div>
                    <div className={'box connect-page__video-player'}>
                      <YouTubePlayer
                        title={'Tesla App - Insecure by Design'}
                        src={'https://www.youtube.com/watch?v=PVwu97tbkQQ'}
                        description={
                          'We proudly present the legacy of XSolve - one of Boldare’s founding companies'
                        }
                      />
                    </div>
                  </LazyLoad>
                </BoxLayoutMobileSingle>
              </Section>
            </div>
          </Section>
        )}
      />
    );
  }
}

export default OurEvents;
